import { render } from "./successModal.vue?vue&type=template&id=d0b7fef6&ts=true"
import script from "./successModal.vue?vue&type=script&lang=ts"
export * from "./successModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__